import Vue from 'vue'
import VueRouter from 'vue-router'

import home from '../views/pageMain/index.vue' //头部和尾部
import index from '../views/Home/index.vue'  //首页

const develop = () => import('../views/Company/develop.vue') //发展历程
const strategic = () => import('../views/Company/strategic.vue') //战略部署
const introduct = () => import('../views/Company/introduct.vue') //集团简介
const brand = () => import('../views/Company/brand.vue') //品牌理念
const honor = () => import('../views/Company/honor.vue') //品牌荣耀

const product = () => import('../views/Product/product.vue') //产品创新

const house = () => import('../views/Business/house.vue')  //住宅开发
const business = () => import('../views/Business/business.vue') //商业运营
const propertyService = () => import('../views/Business/propertyService.vue')  //物业服务
const dwell = () => import('../views/Business/dwell.vue')  //住宅开发弹框

const picture = () => import('../views/News/picture.vue')  //品牌画册
const brandImage = () => import('../views/News/brandImage.vue')  //品牌影像
const social = () => import('../views/News/social.vue')  //社交媒体
const groupNews = () => import('../views/News/groupNews.vue')  //集团新闻
const newsDetails = () => import('../views/News/newsDetails.vue')  //集团新闻详情
const media = () => import('../views/News/media.vue')

const application = () => import('../views/Invite/application.vue')  //我要应聘
const applicateDetails = () => import('../views/Invite/applicateDetails.vue')  //我要应聘详情
const staffStyle = () => import('../views/Invite/staffStyle.vue') //员工风采

const relation = () => import('../views/Relation/relation.vue') //联系我们


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: home,
    children: [
      {
        alias: '/',
        path: '/index',
        component: index,
      },
      {
        path: '/develop',
        component: develop,
      },
      {
        path: '/strategic',
        component: strategic,
      },
      {
        path: '/introduct',
        component: introduct,
      },
      {
        path: '/house',
        component: house,
      },
      {
        path: '/business',
        component: business,
      },
      {
        path: '/propertyService',
        component: propertyService,
      },
      {
        path: '/dwell',
        component: dwell,
      },
      {
        path: '/brand',
        component: brand,
      },
      {
        path: '/picture',
        component: picture,
      },
      {
        path: '/brandImage',
        component: brandImage,
      },
      {
        path: '/social',
        component: social,
      },
      {
        path: '/groupNews',
        component: groupNews,
      },
      {
        path: '/newsDetails',
        name:'newsDetails',
        component: newsDetails
      },
      {
        path:'/media',
        component:media
      },
      {
        path: '/application',
        component: application,
      },
      {
        path: '/applicateDetails',
        name:'applicateDetails',
        component: applicateDetails
      },
      {
        path: '/staffStyle',
        component: staffStyle,
      },
      {
        path: '/product',
        component: product
      },
      {
        path:'/relation',
        component:relation
      },
      {
        path:'/honor',
        component:honor
      }
    ]
  }
]

const router = new VueRouter({
  mode:'history',
  base:'/mobile/',
  routes
})

export default router
